// IE 2026 10 08 / ODOO-5800 (скрины Игоря, стол 2W1_001, dev02): свёрнутое меню «⋮» узкой шапки открывало НЕ ТО, что кнопки широкой шапки —
// «Igor» в «⋮» давал прежнее контекстное wj-menu, а в широкой шапке — панель «User menu»; база — список wj-menu вместо DatabasePicker;
// меню страницы — wj-menu вместо панели «Page menu»; панели Pages / Tasks в «⋮» не было вовсе.
// Одна таблица: чем открывается каждый пункт в ШИРОКОЙ шапке (topbarMenuKinds) — и те же виды в «⋮» (topbarOverflowRows).
// Выключатель fe.ux.topbarOverflowSameMenus (по умолчанию вкл.; false — прежние wj-menu в «⋮», как было).

export function topbarOverflowSame_on(store) {
    try { return !!store && typeof store.setting === 'function' && store.setting('fe.ux.topbarOverflowSameMenus', true) !== false } catch (e) { return true }
}

// Виды пунктов (чем открывается): 'pagesPanel' — PagesPanel, 'menuPanel' — MenuPanel (панель функций), 'dbPicker' — DatabasePicker (всплывашка),
// 'wj' — прежнее wj-menu. ctx — состояние шапки:
//   pageMenuPanel — панель «Page menu» вместо wj-menu (store.menuPanel_on('Page')); pagesIcon — PagesPanel-иконка в блоке меню страницы
//   (pageMenuPanelOn && !pagesOnTitle && !pagesOnRailToggle); tasksIcon — панель «Tasks» в блоке меню страницы (tasksPanelOn && !tasksOnTitle);
//   pageOnTitle — форма меню рабочей области на названии стола (AppTopbar.wsMenuOnTitle): строки меню страницы нет;
//   userPanel — панель «User menu» (store.menuPanel_on('User')); hasDb — у пользователя есть база (store.user.database.title)
export function topbarMenuKinds(ctx = {}) {
    const k = {}
    if (ctx.pagesIcon) k.pages = 'pagesPanel'
    if (!ctx.pageOnTitle) k.page = ctx.pageMenuPanel ? 'menuPanel' : 'wj'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p225 єдине меню робочої області, етап 2): pageOnTitle — форма меню рабочей области на названии стола (оно не сворачивается в «⋮»): строки меню страницы в «⋮» нет
    if (ctx.tasksIcon) k.tasks = 'menuPanel'
    if (ctx.hasDb) k.db = 'dbPicker'
    k.pm = 'wj'
    k.user = ctx.userPanel ? 'menuPanel' : 'wj'
    return k
}

// Прежние виды в «⋮» (флаг выкл.): меню страницы, база, ПМ, пользователь — все wj-menu; Pages / Tasks нет
export function topbarOverflowKinds_legacy(ctx = {}) {
    const k = { page: 'wj', pm: 'wj', user: 'wj' }
    if (ctx.hasDb) k.db = 'wj'
    return k
}

const LEFT = ['pages', 'page', 'tasks'], RIGHT = ['db', 'pm', 'user']

// Строки «⋮»: side — 'left' (свёрнутый блок меню страницы, hideLeft2) | 'right' (база / ПМ / пользователь, hideRight2); kind — см. topbarMenuKinds
export function topbarOverflowRows(ctx = {}) {
    const kinds = ctx.same === false ? topbarOverflowKinds_legacy(ctx) : topbarMenuKinds(ctx)
    const rows = []
    if (ctx.hideLeft2) for (const id of LEFT) if (kinds[id]) rows.push({ id, side: 'left', kind: kinds[id] })
    if (ctx.hideRight2) for (const id of RIGHT) if (kinds[id]) rows.push({ id, side: 'right', kind: kinds[id] })
    return rows
}
